import type { FC } from "react"

import { motion } from "framer-motion"
import styled from "styled-components"

const StyledToggleButton = styled.div<{
  isActive: boolean
  isDisabled: boolean | undefined
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  > p {
    font-size: var(--step--2);
    font-weight: 600;
    text-transform: capitalize;
    color: var(--queen-blue);
  }
  color: black;
  gap: 10px;
  > div {
    > input {
      position: absolute;
      border: 1px solid red;
      opacity: 0;
      cursor: ${({ isDisabled }) => (isDisabled ? `not-allowed` : `pointer`)};
      width: 100%;
      height: 100%;
      z-index: 1;
    }
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
    width: 40px;
    height: 20px;
    background-color: ${({ isActive, isDisabled }) =>
      isActive && !isDisabled ? `#96c6ff` : `#d6d6d6`};
    transition: background-color 0.1s ease-in-out;
    display: flex;
    border-radius: 50px;
    padding: 5px;
    align-items: center;
    div {
      width: 15px;
      height: 15px;
      background-color: ${({ isActive, isDisabled }) =>
        isActive ? `var(--blue)` : isDisabled ? `#919191` : `#636363`};
      transition: background-color 0.15s ease-in-out;
      border-radius: 999px;
    }
  }
`

const spring = {
  type: `spring`,
  stiffness: 700,
  damping: 30,
}

const ToggleButton: FC<
  React.HTMLAttributes<HTMLDivElement> & {
    id?: string
    label?: string
    isActive: boolean
    isDisabled?: boolean
    setAction: (event: React.ChangeEvent<HTMLInputElement>) => void
  }
> = ({ isActive, setAction, label, isDisabled, id, style, ...props }) => {
  return (
    <StyledToggleButton
      isDisabled={isDisabled}
      isActive={isActive}
      style={style}
      data-role="toggle-button"
      {...props}
    >
      <p>{label}</p>
      <div>
        <input
          type="checkbox"
          checked={isActive}
          disabled={isDisabled}
          onChange={
            isDisabled
              ? () => {
                  // intentionally left blank
                }
              : setAction
          }
          id={id ?? `toggle`}
          name={id ?? `toggle`}
        />
        <motion.div
          animate={{
            x: isActive ? `15px` : `0px`,
          }}
          transition={spring}
        />
      </div>
    </StyledToggleButton>
  )
}

export default ToggleButton
